
export const formatUrl = (url, options = {}) => {
  if (DEVELOPMENT || options.development) {
    // proxy through local dev server (see proxy config in vue.config.js)
    return url ? url.replace(/^https?:\//, '') : url;
  }

  return url;
}
